import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
	updateMyAccountDetails,
	updateMyProfilePicture,
} from "../../../actions/companyUserActions";
import { sendPasswordResetMail } from "../../../actions/authActions";
import { useTranslation } from "react-i18next";
import {
	Form,
	Input,
	Alert,
	Space,
	message,
	Modal,
	Card,
	Upload,
	Badge,
} from "antd";
import { Region } from "../../common/layout/region";
import { MailOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import ImageUploadCameraIcon from "../../common/icons/imageUploadCamera";
import ImgCrop from "antd-img-crop";
import { RefreshIcon, EditPenOnPaperRightHandIcon } from "../../common/icons";
import { defaultCompanyLogoURL } from "../../../utils/constants";
import { getSrcFromFile } from "../../../utils/functions/javaScriptHelper";
import { usePreviousState } from "../../../utils/customHooks";
import GalkButton from "../../common/component/button";
import "./style.css";
const { confirm } = Modal;

const MyAccount = ({
	userProfile,
	updateMyAccountDetails,
	updateMyProfilePicture,
	sendPasswordResetMail,
	isActionProgress,
	profilePicture,
}) => {
	const [form1] = Form.useForm();
	const [form3] = Form.useForm();
	const prevActionInProgressValue = usePreviousState(isActionProgress);
	const [isEditable, setIsEditable] = useState(false);
	const [canIResetPassword, setCanIResetPassword] = useState(true);
	const [logo, setLogo] = useState(defaultCompanyLogoURL);
	const [logoObject, setLogoObject] = useState(null);
	const { t } = useTranslation();

	useEffect(() => {
		if (!isActionProgress && prevActionInProgressValue) {
			setIsEditable(false);
		}
	}, [isActionProgress]);

	useEffect(() => {
		setLogo(profilePicture);
	}, [profilePicture]);

	const { emailVerified, isEmpty, isLoaded } = userProfile;

	const updateInformation = (formValues) => {
		updateMyAccountDetails(formValues);
		updateLogo();
		message.success("Data updated ..");
		resetAll();
	};

	const resetPassword = (e) => {
		e.preventDefault();

		confirm({
			title: "Are you sure you want to reset your password?",
			icon: <ExclamationCircleOutlined />,
			content:
				"A mail with password reset link will be sent to your registered mail id. And you will be logged out.",
			okText: "Yes",
			okType: "danger",
			cancelText: "No",
			onOk() {
				sendPasswordResetMail();
				setCanIResetPassword(false);
				message.success("Mail has been sent..");
			},
			onCancel() {
				console.log("Cancel");
			},
		});
	};

	const resetAll = () => {
		form1.resetFields();
		setIsEditable(false);
		setLogoObject(null);
	};

	const fetchFileData = async (file) => {
		if (file) {
			// const file = info.file.originFileObj;

			const isAcceptableFileType =
				file.type === "image/jpeg" ||
				file.type === "image/svg+xml" ||
				file.type === "image/gif" ||
				file.type === "image/png";

			if (!isAcceptableFileType) {
				message.error("You can only upload jpeg/png/svg/gif file!");
			}

			const isLt10M = file.size / 1024 / 1024 < 10;

			if (!isLt10M) {
				message.error("Image must be smaller than 10MB!");
			}

			if (isAcceptableFileType && isLt10M) {
				const url = await getSrcFromFile(file);
				setLogo(url);
				setLogoObject(file);
			}
		} else {
			setLogoObject(null);
		}

		return false;
	};

	const handleLogoUploadChange = ({ fileList: newFileList }) => {
		// if (newFileList.length > 0) {
		// 	let file = newFileList[0].originFileObj;
		// 	const isAcceptableFileType =
		// 		file.type === "image/jpeg" ||
		// 		file.type === "image/svg+xml" ||
		// 		file.type === "image/gif" ||
		// 		file.type === "image/png";
		// 	if (!isAcceptableFileType) {
		// 		message.error("You can only upload jpeg/png/svg/gif file!");
		// 	}
		// 	const isLt10M = file.size / 1024 / 1024 < 10;
		// 	if (!isLt10M) {
		// 		message.error("Image must be smaller than 10MB!");
		// 	}
		// 	if (isAcceptableFileType && isLt10M) {
		// 		let reader = new FileReader();
		// 		reader.onloadend = () => {
		// 			setLogoObject(file);
		// 			setLogo(reader.result);
		// 		};
		// 		reader.readAsDataURL(file);
		// 	}
		// } else {
		// 	setLogoObject(null);
		// }
	};

	const updateLogo = () => {
		if (logoObject) {
			updateMyProfilePicture(logoObject);
		} else {
			message.error("Please select a new logo and then click on save.");
		}
	};

	return (
		<Region>
			{isLoaded && !isEmpty && (
				<>
					<div className="accountSetting_pageTitle">
						{t("left_nav_top_dropdownOptiion_accountSetting")}
					</div>
					<Card
						type="inner"
						title={`${t("basic_information")}`}
						extra={
							isEditable ? (
								<div style={{ display: "flex", gap: "16px" }}>
									<GalkButton
										type="secondary"
										onClick={resetAll}
										disabled={isActionProgress}
										additionalStyle={{ padding: "13px 16px" }}
									>
										{t("editProject_modalAction_cancel")}
									</GalkButton>
									<GalkButton
										type="primary"
										onClick={() => form1.submit()}
										disabled={false}
										loading={isActionProgress}
										additionalStyle={{ padding: "13px 16px" }}
									>
										<RefreshIcon width={14} height={14} />
										{t("editProject_modalAction_submit")}
									</GalkButton>
								</div>
							) : (
								<GalkButton
									type="default"
									onClick={() => setIsEditable(true)}
									additionalStyle={{ padding: "13px 16px" }}
								>
									<EditPenOnPaperRightHandIcon width={14} height={14} />
									{t("edit")}
								</GalkButton>
							)
						}
					>
						<div className="accountSetting_body_container">
							<div className="accountSetting_body_companyLogo_container">
								<div className="accountSetting_body_companyLogo_uploadControl">
									{isEditable ? (
										<ImgCrop rotate cropShape="round">
											<Upload
												name="avatar"
												listType="picture-circle"
												className="avatar-uploader"
												showUploadList={false}
												beforeUpload={fetchFileData}
												onChange={handleLogoUploadChange}
												maxCount={1}
												disabled={!isEditable}
											>
												<img
													className="editableImage"
													src={logo || defaultCompanyLogoURL}
													alt="avatar"
												/>
												<div className="uploadText">
													<ImageUploadCameraIcon height={54} width={54} />
												</div>
											</Upload>
										</ImgCrop>
									) : (
										<img
											className="notEditableImage"
											src={logo || defaultCompanyLogoURL}
											alt="avatar"
										/>
									)}
								</div>
								{isEditable && (
									<div className="accountSetting_body_companyLogo_uploadInstruction">
										<Badge
											status="warning"
											text={`${t("imageupload_instruction1")}`}
										/>
										<Badge
											status="warning"
											text={`${t("imageupload_instruction2")}`}
										/>
										<Badge
											status="warning"
											text={`${t("imageupload_instruction3")}`}
										/>
									</div>
								)}
							</div>
							<div className="accountSetting_body_infoForm">
								{Object.entries(userProfile).length > 0 && (
									<Form
										form={form1}
										layout="vertical"
										initialValues={
											userProfile && {
												name: userProfile.name,
												email: userProfile.email,
											}
										}
										onFinish={updateInformation}
									>
										<Form.Item
											label={t("name")}
											name="name"
											rules={[{ required: true, message: "" }]}
										>
											<Input placeholder="" disabled={!isEditable} />
										</Form.Item>
										<Form.Item label={t("email")} name="email">
											<Input disabled={!isEditable} />
										</Form.Item>
										<Space direction="vertical">
											{emailVerified ? (
												<Alert
													style={{ padding: "5px 10px" }}
													message={`${t("verified")}`}
													type="success"
													showIcon
												/>
											) : (
												<Alert
													style={{ padding: "5px 10px" }}
													message={`${t("not_verified")}`}
													type="warning"
													showIcon
												/>
											)}
										</Space>
									</Form>
								)}
							</div>
						</div>
					</Card>
					<Form form={form3}>
						<Form.Item label={`${t("send_password_reset_mail")}`}>
							<GalkButton
								type="primary"
								onClick={resetPassword}
								disabled={!canIResetPassword}
								additionalStyle={{ padding: "13px 16px" }}
							>
								<MailOutlined />
								{`${t("send")}`}
							</GalkButton>
						</Form.Item>
					</Form>
				</>
			)}
		</Region>
	);
};
const mapStateToProps = (state) => ({
	userProfile: state.firebase.profile,
	profilePicture: state.company.companyUserProfilePicture,
	isActionProgress: state.user.isLoading,
});

export default connect(mapStateToProps, {
	updateMyAccountDetails,
	sendPasswordResetMail,
	updateMyProfilePicture,
})(MyAccount);
